import { handleResponse, handleError, getBaseUrl } from "./apiUtils";

//const baseUrl = process.env.API_URL + "/clubs/";
const baseUrl = getBaseUrl(); //"https://localhost:44354/api/";

export async function getListaCorsi(idScuola, data, type, lang, idAgenzia) {
  return fetch(
    `${baseUrl}scuole/${idScuola}/corsi?data=${encodeURI(
      data
    )}&type=${type}&lang=${lang}&idAgenzia=${idAgenzia}`
  ) //baseUrl + "scuole/" + codScuola + "/corsi?data=")
    .then(handleResponse)
    .catch(handleError);
}

/**
 * Le "Offerte / Pacchetti": i corsi con flag CorsoPrivato, venduti nell'area lezioni private.
 * Stesso payload di getListaCorsi; i due insiemi sono disgiunti.
 */
export async function getListaOfferte(idScuola, data, lang, idAgenzia) {
  return fetch(
    `${baseUrl}scuole/${idScuola}/offerte?data=${encodeURI(
      data
    )}&lang=${lang}&idAgenzia=${idAgenzia}`
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getCorso(idScuola, idCorso, lang) {
  const url = `${baseUrl}scuole/${idScuola}/corsi/${idCorso}?lang=${lang}`;
  console.log("Making API call to:", url);

  try {
    const response = await fetch(url);
    console.log("API response status:", response.status);

    if (!response.ok) {
      console.error(
        "API response not ok:",
        response.status,
        response.statusText
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await handleResponse(response);
    console.log("Processed API result:", result);
    return result;
  } catch (error) {
    console.error("Error in getCorso API call:", error);
    return handleError(error);
  }
}

export async function getListaSessioni(
  idScuola,
  idCorso,
  data,
  lang,
  idAgenzia
) {
  // const s = `${baseUrl}scuole/${idScuola}/corsi/${idCorso}/sessioni?data=${encodeURI(
  //   data
  // )}&idAgenzia=${idAgenzia}&lang=${lang}`;

  return fetch(
    `${baseUrl}scuole/${idScuola}/corsi/${idCorso}/sessioni?data=${encodeURI(
      data
    )}&idAgenzia=${idAgenzia}&lang=${lang}`
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getServiziDisponibili(
  idScuola,
  idCorso,
  data,
  lang,
  idAgenzia
) {
  return fetch(
    `${baseUrl}scuole/${idScuola}/corsi/${idCorso}/servizi?data=${encodeURI(
      data
    )}&idAgenzia=${idAgenzia}&lang=${lang}`
  )
    .then(handleResponse)
    .catch(handleError);
}
